import React from "react";
import styled, { css } from "styled-components";
import useMediaDeviceSelector from "../hooks/useMediaDeviceSelector";
import Microphone from "./icons/Microphone";
import Video from "./icons/Video";

const MediaDeviceSelectorElement = styled.div`
  position: relative;
  border-radius: 5px;
  background-color: var(--background);
  [data-icon] {
    width: 16px;
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

const selectStyle = css`
  font-size: 100%;
  font-family: var(--fontFamily);
  appearance: none;
  padding: 12px;
  padding-right: ${12 + 18 + 12}px;
  padding-left: ${12 + 16 + 12}px;
  width: 100%;
  color: #fff;
  border-radius: 5px;
  background-color: var(--background);
  border: 0;
`;

const MediaDeviceSelect = styled.select`
  ${selectStyle}
  cursor: pointer;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxMCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iI0ZGRiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNLjgzNy41ODdhLjkzNy45MzcgMCAwIDEgMS4zMjYgMEw5IDcuNDI0IDE1LjgzNy41ODdhLjkzNy45MzcgMCAxIDEgMS4zMjYgMS4zMjZsLTcuNSA3LjVhLjkzNy45MzcgMCAwIDEtMS4zMjYgMGwtNy41LTcuNWEuOTM3LjkzNyAwIDAgMSAwLTEuMzI2WiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+);
  background-position: calc(100% - 12px) center;
  background-repeat: no-repeat;
`;

const MediaDeviceLabel = styled.div`
  ${selectStyle}
`;

type Props = {
  kind: MediaDeviceKind;
};
const MediaDeviceSelector: React.FC<Props> = ({ kind }) => {
  const {
    selected,
    setSelected,
    error,
    devices,
    status
  } = useMediaDeviceSelector(kind);
  let label = "";
  const noDevices = !devices || !devices.length;
  if (error) {
    label = "Error finding devices";
  } else if (noDevices) {
    if (status === "pending") {
      label = "Loading...";
    } else if (status === "resolved") {
      label = "No devices found!";
    }
  }

  let icon: React.ReactNode | undefined = undefined;
  if (kind === "videoinput") {
    icon = <Video data-icon />;
  } else if (kind === "audioinput") {
    icon = <Microphone data-icon />;
  }

  return (
    <MediaDeviceSelectorElement data-kind={kind}>
      {}
      {label ? <MediaDeviceLabel>{label}</MediaDeviceLabel> : null}
      {!label && devices && (
        <MediaDeviceSelect
          value={selected ? selected.deviceId : undefined}
          onChange={(e) => {
            const nextSelected = devices.find(
              (d) => d.deviceId === e.target.value
            );
            setSelected(nextSelected || null);
          }}
        >
          {devices.map((d) => (
            <option key={d.deviceId} value={d.deviceId}>
              {d.label}
            </option>
          ))}
        </MediaDeviceSelect>
      )}
      {icon}
    </MediaDeviceSelectorElement>
  );
};

export default MediaDeviceSelector;
